import {useListView} from '../../core/ListViewProvider'
import {UsersListToolbar} from './UserListToolbar'
import {UsersListGrouping} from './UsersListGrouping'
import {UsersListSearchComponent} from './UsersListSearchComponent'

const UsersListHeader = ({onSearch = (s: string)=>{}, onFilter = (params: object)=>{}}) => {
  const {selected} = useListView()

  return (
      <div className='card-header border-0 pt-6'>
        <UsersListSearchComponent onSearch={onSearch} onFilter={onFilter}  />
        {/* begin::Card toolbar */}
        <div className='d-flex align-items-center'>
          {/* begin::Group actions */}
          {selected.length > 0 ? <UsersListGrouping /> : <UsersListToolbar />}
          {/* end::Group actions */}
        </div>
        {/* end::Card toolbar */}
      </div>
  )
}

export {UsersListHeader}
